import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { SharedModule } from '../../../../shared/shared.module'
import { VideoListItemModule } from '../video-list-item/video-list-item.module'
import { VideoListComponent } from './video-list.component'
import { VideoPlayerModule } from '../../../../shared/video-player/video-player.module'
import { TagsModule } from 'src/app/libs/tags/tags.module'
import { VideoPlayerCardModule } from 'src/app/libs/video-player-card/video-player-card.module'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    VideoListItemModule,
    VideoPlayerModule,
    TagsModule,
    VideoPlayerCardModule
  ],
  exports: [VideoListComponent],
  declarations: [VideoListComponent]
})
export class VideoListModule {}
